/**
 * Candidate only — not deployed.
 * Emit a privacy-safe GA4 event for Amazon Attribution CTA clicks on NHT articles.
 */
(function () {
  'use strict';

  var articleKeys = {
    '/blogs/articles/psoas-and-iliacus-the-complete-anatomy-guide-and-why-these-two-muscles-matter-for-your-pain':
      'psm_a14_anatomy_amazon',
    '/blogs/articles/why-foam-rolling-wont-fix-tight-hip-flexors-and-what-actually-works':
      'psm_a07_foam_rolling_amazon'
  };

  function emitAmazonOutbound(link) {
    if (typeof window.gtag !== 'function') return;

    var destination;
    try {
      destination = new URL(link.href, window.location.href);
    } catch (error) {
      return;
    }

    if (!/(^|\.)amazon\.com$/i.test(destination.hostname)) return;
    if (!destination.searchParams.get('maas')) return;

    var articleHandle = window.location.pathname.split('/').filter(Boolean).pop() || 'unknown';
    var pageParams = new URLSearchParams(window.location.search);

    window.gtag('event', 'amazon_outbound_click', {
      measurement_key: articleKeys[window.location.pathname] || ('article_' + articleHandle + '_amazon'),
      article_handle: articleHandle,
      destination_host: destination.hostname.toLowerCase(),
      attribution_tag: destination.searchParams.get('maas'),
      utm_campaign: pageParams.get('utm_campaign') || '(none)',
      gclid_present: pageParams.has('gclid') ? 'yes' : 'no',
      transport_type: 'beacon'
    });
  }

  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest
      ? event.target.closest('a[href]')
      : null;
    if (link) emitAmazonOutbound(link);
  }, true);
})();
